import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_OVERX_URL}/api/v1/sicurezza/`;
const API_LOGOUT_URL = process.env.REACT_APP_DESCOPE_LOGOUT_URL;

export function logoutDescope(oidc, logoutUrl) {
  return axios.get(API_LOGOUT_URL, {
    params: {
      id_token_hint: oidc,
      post_logout_redirect_uri: logoutUrl,
    },
  });
}



const login = (username, password) => {
  return axios
    .post(`${API_URL}login`, {
      username,
      password,
    })
    .then((response) => {
      if (response.data.access_token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch(e => {
      console.log("Err on loginAuth ", e);
      return e;
    });
}

// Token di accesso corrente: prima la chiave dedicata (flusso Descope), poi il
// legacy 'user.access_token', che puo' essere rimasto indietro.
const getAccessToken = () => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) return accessToken;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return (user && user.access_token) || null;
  } catch (e) {
    return null;
  }
};

let refreshInFlight = null;

const requestNewToken = () => {
  const refreshTokenDescope = localStorage.getItem("refresh_token");
  return axios
    .post(`${API_URL}refresh-token`, {
      "refresh_token": refreshTokenDescope
    })
    .then((response) => {
      if (response.data) {
        if (process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED) {
          localStorage.setItem("access_token", response.data.access_token);
          localStorage.setItem("id_token", response.data.id_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
          localStorage.setItem("user", JSON.stringify(response.data));
        } else {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
      }
      return response.data;
    }).catch(error => {
      if (error.response.status === 400 || error.response.status === 401 || error.response.status === 403) {
        window.location.href = process.env.REACT_APP_PORTAL_LOGIN_URL; // Naviga alla pagina di login
        throw error;
      }

    });
};

// Refresh unico: le chiamate concorrenti (401 dell'app e di @revo/liquidate)
// condividono la stessa richiesta in corso. [CSP-3829]
const refreshToken = () => {
  if (!refreshInFlight) {
    refreshInFlight = requestNewToken().finally(() => {
      refreshInFlight = null;
    });
  }
  return refreshInFlight;
};

const resetLocalStorage = () => {
  localStorage.removeItem("user");
  localStorage.setItem("message", "");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("idFlusso");
  localStorage.removeItem("id_token");
}

const logout = async () => {
  // Best effort token refresh before initiating IdP logout
  try {
    await refreshToken();
  } catch (e) {
    // Ignore refresh errors; proceed with best available id_token
  }

  try {
    const idToken = localStorage?.getItem("id_token");
    const baseUrl = process.env.REACT_APP_PORTAL_LOGIN_URL;
    const logoutRedirect = `${baseUrl}`;
    resetLocalStorage();

    if (idToken)  await logoutDescope(idToken, logoutRedirect).then((res) => console.log(res)).catch(e => console.error(e));
    
    localStorage.setItem("lastKnownPath", window.location.href);
    window.location.href = process.env.REACT_APP_PORTAL_LOGIN_URL;
  } catch (e) {
    console.log("Logout request error", e);
  }
};

const getCurrentTokenUser = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const accessToken = localStorage.getItem("access_token");

  if (user && user.accessToken) {
    return JSON.parse(localStorage.getItem("user"));
  }
  if (accessToken) {
    return JSON.parse(localStorage.getItem("access_token"))
  }

  return JSON.parse('{"user":"nouser"}');
};



const AuthService = {
  login,
  logout,
  getCurrentTokenUser,
  refreshToken,
  getAccessToken,
};

export default AuthService;